var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56045 12.0146C6.46904 12.0143 6.37867 11.9952 6.29494 11.9585C6.21122 11.9218 6.13594 11.8683 6.07378 11.8013L2.83378 8.35459C2.71267 8.22552 2.64779 8.05362 2.65341 7.87671C2.65904 7.6998 2.73471 7.53237 2.86378 7.41126C2.99286 7.29014 3.16475 7.22526 3.34166 7.23088C3.51857 7.23651 3.686 7.31218 3.80712 7.44126L6.55378 10.3679L12.1605 4.23459C12.2173 4.16374 12.2881 4.10527 12.3684 4.06276C12.4488 4.02026 12.5369 3.99463 12.6275 3.98744C12.7181 3.98025 12.8092 3.99166 12.8952 4.02096C12.9812 4.05026 13.0603 4.09683 13.1277 4.15782C13.1951 4.21881 13.2492 4.29293 13.2869 4.37562C13.3246 4.45831 13.345 4.54783 13.3468 4.63868C13.3486 4.72953 13.3318 4.8198 13.2975 4.90393C13.2632 4.98806 13.212 5.06429 13.1471 5.12792L7.05378 11.7946C6.99221 11.8628 6.91719 11.9176 6.83344 11.9555C6.74969 11.9933 6.65902 12.0134 6.56712 12.0146H6.56045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b28abbb89aa91966f37f45796e8ae70f.svg";
export { ForwardRef as ReactComponent };